import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import * as moment from 'moment';
import { dayPluralMap } from '../../common/core/pluralMaps';
import { AccountIdService } from '../account/account-id.service';

@Component({
  selector: 'usage-upload',
  styleUrls: ['./usage-upload.component.scss'],
  templateUrl: './usage-upload.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AccountIdService],
})
export class UsageUploadComponent {
  @Input() date: string | null;

  constructor(readonly location: Location) {}

  age() {
    return this.date ? moment().diff(moment(this.date), 'days') : null;
  }

  dayPluralMap = dayPluralMap;
}
